module.exports = "/images/place.png?97191549eb090322637e3aa483f22192";